import { graphql } from '../graphql';

export const startDeviationAnalysis = graphql(`
  mutation StartDeviationAnalysis($input: StartDeviationAnalysisInput!) {
    startDeviationAnalysis(input: $input)
  }
`);

export const deviationJobsQuery = graphql(`
  query DeviationJobs($projectId: ID!) {
    deviationJobs(projectId: $projectId) {
      id
      status
      label
      batchId
      inputJson
      outputJson
      createdAt
      startedAt
      completedAt
    }
  }
`);
